function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('../Scripts/login-pages/', true, /\.js$/));